module.exports = __webpack_public_path__ + "img/magento-migration_small@2x.3b1d32c3.jpg";